<template>
  <m-dialog ref="detailDlg" :btnsave="false" title="">
    <v-row row v-if="warga">
      <v-col cols="12">
        <m-card title="Detil Data Anggota">
          <v-row wrap class="py-0 my-0">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pr-2">
              <v-card text color="#fff" flat>
                <v-container fill-height container--fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" lg="3" align-end colbox>
                      <span class="font-weight-bold title primary--text">Foto Profil</span>
                      <img class="pr-2" contain heigth="472" width="209" :src="warga.foto ? warga.foto.pas_foto : 'img/no-image.jpeg'" alt="avatar" />
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4" align-end colbox>
                      <span class="font-weight-bold title primary--text">Scan KTP</span>
                      <img heigth="408" width="646" :src="warga.ktp ? warga.ktp.origin + '?rand=' + Math.random() : 'img/no-image.jpeg'" alt="avatar" />
                      <m-button
                        v-if="warga && warga.id"
                        dark
                        class="ma-2"
                        color="amber"
                        small
                        depreed
                        textButton="Rotasi 90"
                        action="toAction"
                        @toAction="rotate(urlKtp, -90, warga)"
                      ></m-button>
                      <m-button
                        v-if="warga && warga.id"
                        dark
                        class="ma-2"
                        color="amber"
                        small
                        depreed
                        textButton="Rotasi -90"
                        action="toAction"
                        @toAction="rotate(urlKtp, 90, warga)"
                      ></m-button>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <v-row>
                <v-col cols="12"> <span class="font-weight-bold title primary--text">Identitas Anggota</span></v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="NIK" :value="pVal(warga, 'nik')" />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="Nama" :value="pVal(warga, 'nama')" />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="Kategori" :value="pVal(warga.kategori, 'keterangan')" />
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <p class="ml-4 my-0 py-0 font-weight-bold">Alamat</p>
                  <p class="ml-4 my-0 py-0">{{ pVal(warga, "alamat") }}</p>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="RT" :value="pVal(warga, 'rt')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="RW" :value="pVal(warga, 'rw')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Propinsi" :value="pVal(warga.propinsi, 'keterangan')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Kota/Kabupaten" :value="pVal(warga.kota, 'keterangan')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Kecamatan" :value="pVal(warga.kecamatan, 'keterangan')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Kelurahan" :value="pVal(warga.kelurahan, 'keterangan')" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <v-row>
                <v-col cols="12"> <span class="font-weight-bold title primary--text">Informasi Tambahan</span></v-col>
                <v-col cols="12">
                  <div class="ml-4">
                    <p class="grey--text">Organisasi</p>
                    <ul>
                      <li v-for="organisasi in warga.organisasi" :key="organisasi.index">{{ organisasi.keterangan }}</li>
                    </ul>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="Nomor Telepon" :value="pVal(warga, 'telp')" />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="Pekerjaan" :value="pVal(warga.statuspekerjaan, 'keterangan')" />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info label="Jenis Kelamin" :value="pVal(warga, 'kelamin')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Status Perkawinan" :value="pVal(warga, 'status_perkawinan')" />
                </v-col>
                <!-- <v-col cols="12" sm="12" md="4" lg="4">
                  <m-list-tile-info
                    label="Status Hubungan Keluarga"
                    :value="pVal(warga.status_hubungan_keluarga, 'keterangan')"
                  />
                </v-col> -->
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Tempat Lahir" :value="pVal(warga, 'tempat_lahir')" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Tanggal Lahir" :value="pVal(warga, 'tanggal_lahir') | toSD" />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info label="Agama" :value="pVal(warga.agama, 'keterangan')" />
                </v-col>
                <!-- <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info
                    label="Kota/Kabupaten"
                    :value="pVal(warga, 'golongan_darah')"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <m-list-tile-info
                    label="Kecamatan"
                    :value="pVal(warga, 'status_perkawinan')"
                  />
                </v-col> -->
                <v-col cols="12" sm="4" md="4" lg="4">
                  {{ pVal(warga, "keterangan") }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  components: {},
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      warga: {}
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.getDetilWarga(obj.id);

      return this.$refs.detailDlg.open();
    },
    rotate(url, degree, warga) {
      var obj = {
        derajat: degree,
        url: url,
        warga_id: warga.id
      };
      return this.$store
        .dispatch("warga/rotate", obj)
        .then(() => {
          this.getDetilWarga(this.warga.id);
        })
        .catch(e => e);
    },
    getDetilWarga(id) {
      return this.$store
        .dispatch("warga/getDetil", id)
        .then(res => {
          this.urlKtp = res.ktp.origin + "?rand=" + Math.random();
          this.warga = res;
        })
        .catch(e => e);
    }
  }
};
</script>
